import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { GutTypeData } from 'types/GutType';

export const getGutTypeResponse = async (kitId: string) => {
  const response: { result: GutTypeData[] } = await API.get(
    apiName,
    `${apiBasePath}/gutType/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.MICROBIOME,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
      },
    },
  );
  const flat_response =
    !response?.result?.length || !response?.result[0]?.gut_vaginal_type
      ? null
      : response.result[0];
  return flat_response;
};

export const getGutTypeQuery = (kitId?: string | null) => ({
  queryKey: [apiName, 'gutType', kitId],
  queryFn: () => (kitId ? getGutTypeResponse(kitId) : null),
});

const useGutType = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const gutTypeQuery = useSuspenseQuery(getGutTypeQuery(currentKitId));
  // TODO: display_name should be used as a display name and not an identifier,
  // since we share display_name with vaginal and gut types, but they differ on type, age_low and age_high
  // Preferably, we should define everything, including the character graphic and background url on the database.
  const gutVaginalType =
    gutTypeQuery.data?.gut_vaginal_type?.display_name ?? null;
  return { ...gutTypeQuery, gutType: gutVaginalType, gutVaginalType };
};

export default useGutType;
